<div class="preview-file__link">
  <a target="_blank" [href]="link()">
    <i class="icon-file preview-file__icon"></i>
    <div class="preview-file__name">{{ currentFile()?.originalName }}</div>
  </a>
  <i class="preview-file__menu-icon icon-arrow-down preview-image__menu-icon" (click)="onToggleMenu()"></i>
  @if (isShowMenu()) {
    <ux-context-menu class="preview-file__context-menu" (clickOutside)="onCloseMenu()" [delayClickOutsideInit]="true">
      <!--<ux-context-menu-item menu1 icon="icon-eye" iconSize="11.5" name="Просмотр"></ux-context-menu-item>-->
      <ux-context-menu-item menu1 icon="icon-download" name="Скачать" (click)="onDownloadFile()">
      </ux-context-menu-item>
      <!--<ux-context-menu-item menu1 icon="icon-question" iconSize="13" name="Отправить на почту"></ux-context-menu-item>-->
      <ux-context-menu-item menu1 icon="icon-trash" name="Удалить" (click)="onDeleteFile()"></ux-context-menu-item>
    </ux-context-menu>
  }
</div>
